import { useState } from 'react';
import { apiURL } from '../../consts/URLs';
import { PAYMENTRULES } from '../endpointList';
import { fetchRequest, getOptions } from '../utils';
import { getCookie } from '../../utils/handleCookie';
import { cookieName } from '../../consts/cookie';

export interface Category {
    name: string;
    ordering: string;
}

const token = getCookie(cookieName.token);

const usePaymentRules = () => {
    const [getPaymentRulesResponse, setGetPaymentRulesResponse] = useState<any>();
    const [getPaymentRulesResult, setGetPaymentRulesResult] = useState<any>();

    const [createPaymentRulesResponse, createGetPaymentRulesResponse] = useState<any>();
    const [createPaymentRulesResult, createGetPaymentRulesResult] = useState<any>();

    const [deletePaymentRulesResponse, setDeletePaymentRulesResponse] = useState<any>();
    const [deletePaymentRulesResult, setDeletePaymentRulesResult] = useState<any>();

    const [updatePaymentRulesResponse, setUpdatePaymentRulesResponse] = useState<any>();
    const [updatePaymentRulesResult, setUpdatePaymentRulesResult] = useState<any>();

    const getPaymentRules = () => {
        const url = `${apiURL}/${PAYMENTRULES}`;
        const options = getOptions({ method: 'GET', token: token });
        fetchRequest(url, options, setGetPaymentRulesResponse, setGetPaymentRulesResult);
    };

    const createPaymentRule = (obj: any) => {
        const url = `${apiURL}/${PAYMENTRULES}?name=${encodeURI(obj.name)}`;
        const options = getOptions({ method: 'POST', token: token });
        fetchRequest(url, options, createGetPaymentRulesResponse, createGetPaymentRulesResult);
    };

    const deletePaymentRule = (id: number) => {
        const url = `${apiURL}/${PAYMENTRULES}/${id}/delete`;
        const options = getOptions({ method: 'DELETE', token: token });
        fetchRequest(url, options, setDeletePaymentRulesResponse, setDeletePaymentRulesResult);
    };

    const updatePaymentRule = (obj: any) => {
        const url = `${apiURL}/${PAYMENTRULES}/${obj.id}?name=${encodeURI(obj.name)}`;
        const options = getOptions({ method: 'PUT', token: token });
        fetchRequest(url, options, setUpdatePaymentRulesResponse, setUpdatePaymentRulesResult);
    };

    const RESPONSES = {
        getPaymentRulesResponse,
        createPaymentRulesResponse,
        deletePaymentRulesResponse,
        updatePaymentRulesResponse,
    };

    const RESULTS = {
        getPaymentRulesResult,
        createPaymentRulesResult,
        deletePaymentRulesResult,
        updatePaymentRulesResult,
    };

    const CTAs = {
        getPaymentRules,
        createPaymentRule,
        deletePaymentRule,
        updatePaymentRule,
    };

    return { RESPONSES, RESULTS, CTAs };
};
export default usePaymentRules;
